import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArdourComponent } from './simple-icons-ardour.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArdourComponent ],
    exports:      [ SimpleIconsArdourComponent ],
    bootstrap:    []
})
export class SimpleIconsArdourModule {}
